import React, { ReactNode } from 'react';
import { useTheme } from '../../themer';
import { ArrowForwardIcon } from '../Icon';
import { IIconLinkProps, StyledIconLink } from './IconLink';
import { LinkText } from './LinkText';
import { VisuallyHidden } from '../VisuallyHidden';

export interface IArrowLinkProps extends IIconLinkProps {
	inverted?: boolean;
	children: ReactNode;
	screenReaderTitle?: string;
}

export function ArrowLink({
	children,
	inverted,
	screenReaderTitle,
	...rest
}: IArrowLinkProps) {
	const theme = useTheme();
	const IconComponent = theme.link.ArrowLinkIcon ?? ArrowForwardIcon;

	return (
		<StyledIconLink inverted={inverted} {...rest}>
			<LinkText>
				{!screenReaderTitle ? (
					children
				) : (
					<>
						<span>{children}</span>
						<VisuallyHidden>{screenReaderTitle}</VisuallyHidden>
					</>
				)}
			</LinkText>
			<IconComponent aria-hidden="true" />
		</StyledIconLink>
	);
}
